module.exports = __webpack_public_path__ + "static/media/belcolor__3.9f86a3f5.jpg";